module.exports = __webpack_public_path__ + "assets/dark.b1791b5c.svg";